// imports
import Carousel from 'minsky-kit/js/components/Carousel';

// class definition
export default class RelatedCarousel extends Carousel {
    // constructor
    constructor (args = {}, objectName = 'RelatedCarousel') {
        args.debug = args.debug || false;

        // setting
        args.settings = {
            preventClicks: false,
            loop:          true,
            slidesPerView: 1,
            spaceBetween:  20,

            breakpoints:   {
                // when window width is >= 320px
                620: {
                    slidesPerView: 2,
                    spaceBetween:  20,
                },
                // when window width is >= 480px
                720: {
                    slidesPerView:  3,
                    allowTouchMove: false,
                },
            },
        };

        // super
        super(args, objectName);
    }

    // methods
    destroy () {
        // super destroy
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
